export default {"src":"/_next/static/image/public/assets/feature-images/fr/spelling.e1553ed743435b12821898dbd723d327.svg","height":381,"width":519};